import css from '../../../utils/css';

const joeThemeCss: string = css`
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 300;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSDtFlzAA.ttf)
      format('truetype');
  }
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 400;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSD6llzAA.ttf)
      format('truetype');
  }
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 500;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSD2FlzAA.ttf)
      format('truetype');
  }
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 700;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSDDV5zAA.ttf)
      format('truetype');
  }

  [data-fpsm-theme] {
    --font-family-1: 'IBM Plex Sans';
    --font-family-2: 'IBM Plex Sans';
    --font-family-3: 'IBM Plex Sans';

    --joe-background: #ffc627;
    --joe-orange: #ffc627;
    --joe-black: #132428;
    --joe-dark-blue: #0f2d37;
    --joe-almost-white: #f7f7f7;
    --joe-light-gray: #e5e5e5;
    --joe-nickel-gray: #7d7d7d;
    --joe-gray: #757575;
    --joe-blue: #0059b5;
    --joe-dark-blue: #01448a;
    --joe-white: #ffffff;
    --joe-disabled: #b2b2b2;

    --cxy-font-family-sans: var(--font-family-1), sans-serif;
    --widget-font-family: var(--font-family-1), sans-serif;

    --cxy-color-container-inverse: var(--joe-background);
    --cxy-color-surface-primary-default: var(--joe-background);
    --cxy-color-interactive-secondary: var(--joe-orange);
    --cxy-color-interactive-senary: var(--joe-white);
    --cxy-color-interactive-senary-hover: var(--joe-light-gray);
    --cxy-color-content-prompt: var(--joe-white);

    --cxy-color-container-light: var(--joe-light-gray);
    --cxy-color-container-subtle-brand: var(--joe-light-gray);
    --cxy-color-border-brand-deep: var(--joe-nickel-gray);
    --cxy-color-interactive-quinary: var(--joe-light-gray);
    --cxy-color-interactive-quinary-hover: var(--joe-gray);

    --cxy-color-interactive-tertiary: var(--joe-blue);

    --cxy-color-interactive-primary: var(--joe-blue);
    --cxy-color-interactive-primary-hover: var(--joe-dark-blue);
    --cxy-color-interactive-quaternary: var(--joe-blue);
    --cxy-color-interactive-quaternary-hover: var(--joe-dark-blue);
    --cxy-color-content-primary: var(--joe-black);
    --cxy-color-content-feature: var(--joe-black);
    --cxy-color-content-inverted: var(--joe-black);

    --cxy-color-brand: var(--joe-blue);

    [class^='_eventWrapper'] {
      color: var(--joe-orange);
    }

    [class^='_container_']:first-of-type {
      color: var(--joe-black);
    }

    [class*='_bestOddsButtonContent_'] {
      color: var(--joe-white);
    }

    [class*='_bookieSelectorWrapper_'],
    [class*='_bookieSelectorWrapper_'] > button span {
      color: var(--joe-black);
    }
    [class*='_bestOddsButtonContent_'] path {
      fill: var(--joe-white) !important;
    }

    [class*='_subeventPickerDropdown_'] {
      background-color: var(--joe-black);
      border: unset;
    }

    [class*='_subeventPickerDropdown_'][class*='_open_'] {
      color: var(--joe-white);
    }

    [class^='_subeventTeamsWrapper'] {
      font-size: 16px;
    }
    [class*='_prePopulatedDateTime_'],
    [class*='_subeventStartTime_'] {
      color: var(--joe-black);
    }

    [class*='_expandableOfferButton_'] {
      color: var(--joe-white);
      background-color: var(--joe-black);
    }

    [class*='_expandableOfferButton_']:hover {
      color: var(--joe-white);
      background-color: var(--joe-black);
    }

    [class^='_subeventTeamsWrapper'] {
      font-size: 16px;
    }

    [class*='_radioPickerButton'][class*='_isSelected'] {
      background-color: var(--joe-black);
      border-color: var(--joe-black);
      color: var(--joe-white);
    }

    [class*='_selectButton'][class*='_isSelected'] {
      background-color: var(--joe-white);
    }

    [data-testid='header']::before {
      content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIyMiAyNCI+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTAgMmgzMnYyMkgweiIvPjxwYXRoIGZpbGw9IiMxMzI0MjgiIGQ9Ik00NC4xNTYgMjNWMy40NTZoOS40OTJxMi40MDggMCAzLjc4IDEuMzcydDEuMzcyIDMuNjRxMCAxLjQ4NS0uNTA0IDIuNDA4LS40NzYuODk2LTEuMzE2IDEuMzE2YTQuNDUgNC40NSAwIDAgMS0xLjgyLjQ3NnYuMTY4cS43IDAgMS40NTYuMjUydDEuNDI4Ljc4NCAxLjA5MiAxLjQyOHEuNDIuODY4LjQyIDIuMTI4IDAgMS41NC0uNjcyIDIuOGE1LjIgNS4yIDAgMCAxLTEuNzkyIDIuMDE2cS0xLjEyLjc1Ni0yLjU3Ni43NTZ6bTQuMjU2LTguMDY0djQuNDhoNC45cS41NiAwIC45NTItLjE5Ni40Mi0uMjI1LjY0NC0uNjE2LjIyNC0uMzkyLjIyNC0uOTUyVjE2LjdxMC0uNTYtLjIyNC0uOTUyYTEuNCAxLjQgMCAwIDAtLjY0NC0uNTg4cS0uMzkyLS4yMjQtLjk1Mi0uMjI0em0wLTcuODk2djQuNDI0aDQuMjI4cS41NiAwIC45NTItLjE5Ni40Mi0uMjI1LjYxNi0uNjE2LjIyNC0uNDIuMjI0LS45OHYtLjg0cTAtLjU2LS4yMjQtLjk1MmExLjI0IDEuMjQgMCAwIDAtLjYxNi0uNjE2cS0uMzkyLS4yMjQtLjk1Mi0uMjI0ek03Ni4xMzIgMjNoLTEzLjNWMy40NTZoMTMuM3YzLjc4aC05LjA0NHY0LjAwNGg3Ljc1NnYzLjc1MmgtNy43NTZ2NC4yMjhoOS4wNDR6TTkzLjI4IDcuMjM2aC01LjI5MlYyM2gtNC4yNTZWNy4yMzZINzguNDR2LTMuNzhoMTQuODR6TTEwMi44MDggMjNWMy40NTZoOS40OTJxMi40MDkgMCAzLjc4IDEuMzcyIDEuMzcyIDEuMzcyIDEuMzcyIDMuNjQgMCAxLjQ4NS0uNTA0IDIuNDA4LS40NzYuODk2LTEuMzE2IDEuMzE2YTQuNDUgNC40NSAwIDAgMS0xLjgyLjQ3NnYuMTY4cS43IDAgMS40NTYuMjUydDEuNDI4Ljc4NCAxLjA5MiAxLjQyOHEuNDIuODY4LjQyIDIuMTI4IDAgMS41NC0uNjcyIDIuOGE1LjIgNS4yIDAgMCAxLTEuNzkyIDIuMDE2cS0xLjEyLjc1Ni0yLjU3Ni43NTZ6bTQuMjU2LTguMDY0djQuNDhoNC45cS41NiAwIC45NTItLjE5Ni40Mi0uMjI1LjY0NC0uNjE2LjIyNS0uMzkyLjIyNC0uOTUyVjE2LjdxMC0uNTYtLjIyNC0uOTUyYTEuNCAxLjQgMCAwIDAtLjY0NC0uNTg4cS0uMzkxLS4yMjQtLjk1Mi0uMjI0em0wLTcuODk2djQuNDI0aDQuMjI4cS41NiAwIC45NTItLjE5NmExLjQgMS40IDAgMCAwIC42MTYtLjYxNnEuMjI1LS40Mi4yMjQtLjk4di0uODRxMC0uNTYtLjIyNC0uOTUyYTEuMjQgMS4yNCAwIDAgMC0uNjE2LS42MTZxLS4zOTEtLjIyNC0uOTUyLS4yMjR6bTE0LjMwOC0zLjU4NGg0LjE0NFYxNS40NHEwIDEuMzcyLjMzNiAyLjI5NkEyLjc4IDIuNzggMCAwIDAgMTI3IDE5LjEwOHEuNzg0LjQ0OCAyLjA0NC40NDh0Mi4wMTYtLjQ0OGEyLjc4IDIuNzggMCAwIDAgMS4xNDgtMS4zNzJxLjM2NC0uOTI0LjM2NC0yLjI5NlYzLjQ1Nmg0LjE0NHYxMS41MzZxMCAyLjg4NC0uNzU2IDQuNzMydC0yLjQzNiAyLjc0NHEtMS42OC44NjgtNC40OC44Njh0LTQuNDgtLjg2OHEtMS42OC0uODk2LTIuNDM2LTIuNzQ0dC0uNzU2LTQuNzMyek0xNDkuNDY2IDIzaC05LjI5NnYtMy4zODhoMi41MlY2Ljg0NGgtMi41MlYzLjQ1Nmg5LjI5NnYzLjM4OGgtMi41MnYxMi43NjhoMi41MnptMTUuMjQ5IDBoLTExLjcwNFYzLjQ1Nmg0LjI1NlYxOS4yMmg3LjQ0OHptMy4xNDQgMFYzLjQ1Nmg3LjM2NHEyLjYwNCAwIDQuNTM2IDEuMDkydDIuOTk2IDMuMjc2cTEuMDY0IDIuMTU2IDEuMDY0IDUuNDA0dC0xLjA2NCA1LjQzMnEtMS4wNjQgMi4xNTYtMi45OTYgMy4yNDhUMTc1LjIyMyAyM3ptNC4yNTYtMy43OGgzLjEwOHExLjI2IDAgMi4xODQtLjQ3NmEzLjEgMy4xIDAgMCAwIDEuNC0xLjQ1NnEuNTA0LTEuMDA4LjUwNC0yLjU0OHYtMy4wMjRxMC0xLjU2OC0uNTA0LTIuNTQ4YTMuMSAzLjEgMCAwIDAtMS40LTEuNDU2cS0uOTI0LS40NzYtMi4xODQtLjQ3NmgtMy4xMDh6TTIwMC42ODMgMjNoLTEzLjNWMy40NTZoMTMuM3YzLjc4aC05LjA0NHY0LjAwNGg3Ljc1NnYzLjc1MmgtNy43NTZ2NC4yMjhoOS4wNDR6bTcuOTYzLTcuMTY4VjIzaC00LjI1NlYzLjQ1Nmg5LjI2OHExLjgyIDAgMy4xMzYuNzg0YTUuMzYgNS4zNiAwIDAgMSAyLjA0NCAyLjE4NHEuNzI4IDEuNC43MjggMy4yNzYgMCAxLjk2LS44OTYgMy40NzItLjg2NyAxLjQ4NS0yLjY2IDIuMTU2TDIxOS44NDYgMjNoLTQuNzMybC0zLjQxNi03LjE2OHptMC0zLjU4NGg0LjQ4cS42NDUgMCAxLjA5Mi0uMjI0LjQ0OC0uMjI1LjctLjY0NC4yNTItLjQ0OC4yNTItMS4wNjRWOS4wODRxMC0uNjQ1LS4yNTItMS4wNjRhMS42NyAxLjY3IDAgMCAwLS43LS42NDRxLS40NDctLjIyNS0xLjA5Mi0uMjI0aC00LjQ4eiIvPjxkZWZzPjxwYXR0ZXJuIGlkPSJhIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBwYXR0ZXJuQ29udGVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+PHVzZSB4bGluazpocmVmPSIjYiIgdHJhbnNmb3JtPSJtYXRyaXgoLjAwNDYyIDAgMCAuMDA2NjkgLS4xNTggLS4wODIpIi8+PC9wYXR0ZXJuPjxpbWFnZSB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQVIwQUFBQ3hDQVlBQUFENXcybGFBQUFBQ1hCSVdYTUFBQXNUQUFBTEV3RUFtcHdZQUFBTTgwbEVRVlI0bk8zZGU0eWNWUjNHOGUrN3ZlQ1djaW5XRmhRSklJMlVSc0NFQ2tJVkVFV05rR2lDU0tJU2pSSUpFcXdRZ3dsaUlTU1lZQUxpaFFnUmpSY01BakVHUXdVcFhnQlJDS1RjUWdzdDBwUzdyRUs1Rk9sdWQvemp6RGpEZE9kKzN2TTc1ejNQSjVuczd1enNlMzQ3ODc3UGU5N3JLV3ExR2lJaW9ZeFpGeUFpZVZIb2lFaFFDaDBSQ1VxaEl5SkJLWFJFSkNpRmpvZ0VwZEFSa2FBVU9pSVNsRUpIUklKUzZJaElVQW9kRVFsS29TTWlRU2wwUkNRb2hZNklCS1hRRVpHZ1psc1gwR3Joa3FXai9IblI4cjF1RWlUREtxamcvRE94WVoxMUNmOFhWZWlNNEJ2QUxzQWJ3UGFXeDNUOWE2MytmV05tNmpWVEZUMSszK2sxdFpiSGRQMjVPY0FWZlV3dkpnVXdEMWdNTEtsL0hRY1dBcnZSL044YjcrTkx3QVR3T3ZBOHNMNys4OVpnRmZ1eEIzQVJNSW43L0ZvLzQ2TGxhL3Q4MUcxK0tucDhuVW10dy9lZFh0UCtmQTAzMzROYnhzL0YvVTlSS0dLNmMrQ1FQWjB4bW05d3JPWVMwWWMrZ3dJWEtCOEFqZ1pPQVBiM01OMEhnZHVBMWNBRHVDQ0taNGJiMGI3QUU5WkZsR0RuaVEzcm9sa0JwTjdUS1dpdWVmcnBuWVQwQm01TnY0QjRGN1F4NENUZ1RGemcrSFp3L2ZIMStzKy9BNjRFYmlITzkyUzY5MHVTTW8zN2pLUDZ2NnF5SXptMndBSFlxZjZJVFFITUIxYmllb2kvb1p6QW1ja25nVDhBVzREVGNEM0FtTVFZaEtPSWN2bU9zcWdCeFR5anhQYit6Z1V1QkY0QkxqT3NZeGZnS3R3K29LOFI1MHFqU3FKNmYyTmJLS29tbGcrN0FJNENOZ0huMjVieUptUEE5NENIZ0VOTks1RmdVZytkeHA3NldNVVFPbVBBZDRFN2diMk1hK2xrR2JBV1dJWHRleGJENTFXR3FKYVIxRU1uZHRZejhUdUJSNEJ6ak92bzF3WEFHdHcrSjZtb3FvUk9ySWZNTFVObk9iQVplTGRoRGNQNEVPNjhueVVHYlZ1dkpMSlFsZENac2k2Z0E2dVorSGpnSHFPMmZaZ0ZQQWFzc0M1RS9LdEs2TVI4NGwxb0g4V2RCMU1GZHdDSEIyeFBQWjBBcWhJNnNXNWVoYlljdU5tNkNNLytqTTJtbHBSRW9WT3VrR3ZPUmFTOVNkWEpPSzdIbzUzTEZWR1YwSW5xTkc4RFk4QmZySXNvMFdMZ1Jzb1BjVzFlQlZDVjBJbnFQQVFERndJajNSY2tBY2ZpTHQyUXdVVzFmQ2gwMHJjTStKWjFFWUZjQ3V4blhZU01waXFoazJ1M3VBQithRjFFWUQ4bTM4KzdFcW9TT3JrNkdUakd1b2pBamdjK2JsMkVERStoazY0Q3VNUzZDQ081L3QrVlVKWFF5WEdmenNuQVB0WkZHRm1HemxaT1ZsVkNKemNGN3VMSW5GMWtYWUFNcHlxaGsxdFBaeWx3b0hVUnhvN0JYVVV2aVZIb2xLdXN1cjVRMG5SVGM0SjFBWW1JNnVSWmhVNTZDdHlRT3dKbld4ZVFDSVZPQ1hJS25kdzNxMW9kZ0x2bVRMcUw2dHJFcW9UT051c0NBdnFnZFFHUldXNWRnQXltQ3FIVEdJMHlGMGRaRnhDWkU5RVp5cjNNc1M2Z1ZlcUQ3WUhidExvSjJKdG1qNmRvZTB6WEgxTzRydVlVOENraSt6RDZVQkJ1aktwdW5zUGRVblJQWUhmVFN0SWVSZUt2dUdHWVorR1d4VEdhODJ4RFk5NnQxWC9mZU5EMnVzWlExbFAxUjJOWm1GZWZkalEzdXF0SzZIeHBodWNhMnNmZGJqejNPR2xlUExpdllkdW5BOWNBcjdVOE53ODRDN2pZcENJNHhLaGRIODdBM1RoL3BubTBrMDY5dW1UMmExWmg4d3FhUTlITU5DUk5wMkZxVXV5U1c1MkJ2TG5lOXBYQXE3ejV2WDROK0E1d0VHNnM4dERlZ3IvTjY5QUxibVA1RzJRb3BmWjVQZlpobUhaUWxkQVpSb2dQeW5ld0xmQTh2WDRkQnp6WjR6WHJzTHNRMCtwOWtTRW9kTkt5czBHYkZ3QWIrM3p0dmNEUHlpdWxvM0dETm4xSWNSNGNXYzZoaytMbWxVWG9YRGZnNjY4cHBZcnVkalZvMDRjVTU4R1I1Unc2SWZpZXFTeDIvSzhmOFBVUGxGSkZkNmtkaGN4YXpxR1RaZGQyUUZzQy9jMm9VdTB4cEZyM1NISU9IZWt0bGZrank0VTNWYW5NVkdWSThlaFZhT29ObGl2TDl6Zm4wRWxSNmlFbW90QVJrYkFVT2lKMnRIa2xJbEsybkVNbnk3V01pTFdjUTBkRURDaDBSQ1FvaFk1MG8wMVE4UzduME5FQ0pXSWc1OUFSRVFNS0hSRUpLdWZRMGVhVldNdHlIc3c1ZEVURWdFSkhwRWtYMUFhUWMraGsyYld0S0lWRlFuSU9IUkV4b05BUmthQVVPaUlTbEVKSFJJSlM2SWpZMldaZGdBV0xjWlJFeEhrdjdpanFPTTJqcVdQc09NYjU5cGFmSHdXbUE5Ym9uVUpIeE02Z282Y0N2QU40eG5jaElXbnpxbHc2RjBoOG1BUmVybitmL0R5bG5vNUkvT2JRSERvNStSTWgxZE1SU1l0Q0oySEpmM2dpS2NvNWRFVGFwYkMvSlBtVnBVSkhSSUpTNkloSVVBb2RxWUxrTnpseWtuUG9hRVlWTVpCejZFaHZDbWJ4VHFFaklrRXBkRVFrS0lXT2lBU1ZjK2hvZjRXSWdaeERSMFFNS0hSRUpDaUZqa2hhVXJnK3JDdUZqbFJCOGd0aVRoUTZJaEtVUWtja0xjbjM2aFE2SW1sUjZJaElVQW9kNlNyNUdVU2lrZlJZVjYwVU9pSnBhQ3lyeVo5SnJ5Rm9ST3ljQVd6RUxZZXR2ZUxXWUtuaGVqa0ZiaVRRRjRKVlZ4S0ZqbFJCcXB1eE53SlBXeGNSbWphdlJPek1zaTdBZ2tKSHhFNnFQYlNSS0hSRUpDaUZqb2dFbFhQb1pObTFsYWdrZi9oN0dEbUhqb2kxTEZkOENoMFJDVXFoSTlLVVpjOGpOSVdPaUFTbDBCR1JvQlE2SW5heTNKekxPWFN5L01CRnJPVWNPdEpibHVlUkJKVGxpaytoVTY0c1p5cVJiaFE2SWhKVXpxR2pYb2hZeTNJZVZPaUlTRkE1aDg1YzZ3SVNvQjNKNGwzT29iT3pkUUVpT2NvNWRCWmJGeUNTbzF4RFo2RjFBUklsYlU0R2tHdm9IR1pkZ0FpWmhseXVvWE5Lb0hZYU05VlVvUFo4eTNLaGtITGxHRHJ6Z1ZNRHRaWDZRcHZLYVFXcDFDbmtHVHJuQld5ckFGNzBPTDNRQzlmOElmNW1kOTlGU0xYa0ZqcEhBdDhNM09abWo5T3kyRXg3MTRDdlgxSktGZDFOR3JUcFErbzk0YUhrRkRxSEFEY1p0SHVmeDJtOTZuRmEvZnJjZ0svL1lpbFZkTGZGb0UwZkZEb1ZkaEp3UHpaZC8wMGVwL1dHeDJuMWF4V3dUNSt2UFFUNGNvbTFkTExWb0UwWlVveWhzeDkrMWdBRmNDQndIWEM5aCtrTjYyNlAwNXJ3T0sxQnJLYjMvcDI5Z1ZzQzFESVRuL3ZOUXNweUIvaHM2d0xhN0FROERrd0R2d0RXQTNjQ3p3TlAwbnZiL2EzMXg5SEFWNEdEUzZ1MGZ4czhUc3ZuL3FGQkxLdTMvVmxjc0xRdkxKOEhmaDY2cUxwSjRIV2p0a2RWc09NS3R2MW5IOEVVVmJqRkZqcVR1RGY5RldiZU4vQTY4Q3p3RlBBTUxxVDJCdllGM2hhbXhMNU40M3FTbXp4UGR5TndnT2RwOW1NQnJzY0RjQS91L2Q4TE9OeWdsbFpyamRzZnhiM0FMSnJMWVhzSTFYaHpZSFQ3WGV0ejA3aGxhVHV3Q1BmWlJiTUpHbHZvTk43VTNUdjhmaHpZdi82STNSaHdLLzdYTXYvQUpuUmF2Yys0L1ZacmlXeE5Qb0JGSlU1N3N2NllTMlJIOTJMYnB6UEh1Z0RQZnU5NWVqWGdEcy9UVE4yTjFnVkVhZzdOVHNWMnkwTGF4Ulk2c2RVenFsdExtT2J0SlV3elpmZGFGeEN4eGoyam90cWlxZHBDSHBOLzRYYUUrL1pvQ2ROTTFWTzQ5MW02bTJWZFFDdUZUbmwrVXRKMGE4QWxKVTA3TlpkYUY1Q0lxUFo1S1hUSzg2c1NwMjExZURvMk4xZ1hrQWlGVGdZZUF0YVZPUDExd01NbFRqOEZ0K1BPM1pMRUtIVEtVWGEzdndaY1ZISWJzVHZmdWdBWmprTEh2NWVCYXdLMGN6MXVSMnFPSGtKSDhaS2wwUEZ2RldGT3hxb0I1d1JvSjBibldoY2d3MVBvK0xVVitGSEE5cTdIN3dXbEtmZ1RjTE4xRVRJOGhZNWZaeEQybFBNYWNIckE5bUp3R3BFZGpVbEFWUGZ0VWVqNDgzZHNEbVhmRDF4aDBLNkZWY0Evcll1UTBTaDAvUG1NWWR0bjRxNCtyN0tIMFJHN1NsRG8rSEVxdHVlTTFJRGpETnN2MjFiZy9aUy9XYVhOdGdBVU9xUDdLZkJMNnlKd045bGFZVjFFU1paamMzOW9LWUZDWnpSL3hPM1lqTVhmZ0U5WUYrSFpDdUFSNnlJU3B4M0pGWEVYY0NMdUxtMHhXVTExZ21jRkxraGxORkZ0TmlwMGhuTVhjQ3l3emJxUURsWURSMWdYTWFKbEtIQXFTYUV6dU90d2ErQllBNmZoYnR4dFhaKzJMbVJBandHTDBTWlZaY1VXT2xGMUEyZXdFamlGK090c2VBSVhQTCsyTHFSUFZ3TkwwWTI1S2kyMjBHbUlyUmZ4SUhBUWNEbnBCRTdETnR6UU1aL0dYWXdhbzM4REg4UHRsSTl0SDVsNEZsdm9UT0lXNnJuRU0vTjlCVGlVY3UrUEU4SU53RUxnWXV0QzJsd0F2SjJaeDlPU0Nvb3RkS1p3STBtdXhMYTJsNEN6NnJWY1JYVVdoa25nUE56UUo5ODJydVZzM0w2YkM0bXZaMXMxc2F6QWdmaENCOXpacDVmamFqc1crRDVoeHZDZXd0MThhem13Qi9BRDRMVUE3VnA0QVhkSndSandZZURhUU8xZWl6dHplZ3k0akhqMzNVUTFaTXNJYW0xZm8xRFVhdkhVczNESjBrNi9LbkFEekwwSE9Bd1hERWZRZTN6dGJoN0REVjl5Rys1aXpmVkU5dUVFTmc4NEVuZU96MGR3aDZ4SGRSOXVzMmtON21oYU5LTk1kckFmMWJ5Z2RIeGl3N3IvV2hmUkVOVjRPRjNVY0dPQ2J3Qitpd3VoOGZwakViQW5zQ3R1d1drOFB3L1lCWGdPMTJQNUQyNkg1Vk80VStwZkpPK1FhYmNWRnc1cjZqL1B3NDBMZndCdU0yZyticC9RYnV3NHZPMFdZQUwzUGorTEd5Wm5DL0dIVEx1WGNiM2RTWnBiQVkyaGVzZm9QTTc0b0QyS1h1T1hkekxUOURzOXQ3MCszZG00WG53MFV1bnBpSVRTSHFpVk1MRWhudU1nVVlXT2lGUmZqRHVTUmFUQ0ZEb2lFcFJDUjBTQ1V1aUlTRkFLSFJFSlNxRWpJa0VwZEVRa0tJV09pQVNsMEJHUm9CUTZJaEtVUWtkRWdsTG9pRWhRQ2gwUkNVcWhJeUpCS1hSRUpLai9BVlBEQ2NHZUU1cHlBQUFBQUVsRlRrU3VRbUNDIiBpZD0iYiIgd2lkdGg9IjI4NSIgaGVpZ2h0PSIxNzciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiLz48L2RlZnM+PC9zdmc+');
      width: 100%;
      text-align: center;
    }

    [data-testid='header'] > img {
      display: none;
    }

    [data-testid='header'] {
      grid-template-columns: 100%;
    }

    [data-testid='market-button'] {
      background-color: var(--joe-black);
      border: 1px solid var(--joe-black);
      color: var(--joe-white);
    }

    [class^='_clickOutWrapper'] svg,
    [data-testid='market-button'] svg {
      filter: invert(100%) brightness(200%) contrast(100%);
    }

    [class*='_iconButton_'] {
      color: var(--joe-black);
    }
    [class*='_betLegs'] {
      color: var(--joe-orange);
    }

    [class*='_betLegs'] > [class*='_bestOdds'],
    [class*='_betLegs'] > [class*='_alert'],
    [data-testid='bet-item'],
    [data-testid='leg-name'] {
      color: var(--joe-black);
    }

    [class^='_bulletCircleInner'] {
      background-color: var(--joe-white);
    }

    [class^='_bulletLine'],
    [class^='_bulletCircleOuter'] {
      background-color: var(--joe-gray);
    }

    [data-testid='leg-market'] {
      color: var(--joe-gray);
    }

    [class^='_priceOddsWrapper_'] svg {
      fill: var(--joe-white);
    }

    [class*='_price_'][class*='_active'] {
      [class^='_priceOddsWrapper_'] svg {
        fill: var(--joe-black);
      }
    }

    [class^='_bestOddsLabel'] {
      color: var(--joe-black);
    }

    [data-testid='multi-header'] {
      margin-top: 1.2em;
    }

    [class^='_subeventTeamsWrapper'] > [class^='_text'],
    [class^='_subeventTeamsWrapper'] > span {
      font-family: var(--font-family-2), sans-serif;
    }

    [class^='_editSelectionsButton'],
    [class^='_bestOddsSelection'] > button > span {
      font-family: var(--font-family-3), sans-serif;
      text-transform: uppercase;
    }

    [class*='_offersModal_'] {
      background-color: #f7f7f7;
      border-radius: 10px;
      overflow: hidden;
    }

    [class*='_offersModalHeader_'] {
      color: var(--joe-black);
    }

    [class*='_offersModalTitle_'] {
      color: inherit;
      font-family: var(--font-family-2);
    }

    [class*='_offersModal_'] [class*='_offer_'] button,
    [data-testid^='tab-button-'] {
      text-transform: capitalize;
    }

    [class*='_tabButtons_'] button {
      background-color: var(--joe-white);
      color: var(--joe-black);
      border: 1px solid var(--joe-black);
    }

    [class*='_tabButtons_'] button[class*='_isInverted_'] {
      background-color: var(--joe-black);
      color: var(--joe-white);
      border: 1px solid var(--joe-white);
    }

    [class*='_expandedOfferDetail_'] button {
      background-color: var(--joe-black);
      color: var(--joe-white);
      border: 1px solid var(--joe-black);
    }

    [class*='_offersModal_'] [data-testid^='offer-button-'] {
      border-radius: 6px;
      background-color: var(--joe-black);
      color: var(--joe-white);
      border: 1px solid var(--joe-black);
    }

    [class*='_bestOddsLabel'],
    [class*='_isMarketSelectView'] > button,
    [class^='_addMarketSelect'] > button {
      text-transform: capitalize;
    }

    [class^='_clickOutWrapper'],
    [data-testid='bookie-price'] {
      color: var(--joe-black);
      background: var(--joe-white);
      border: 1px solid var(--joe-black);
    }

    [class^='_clickOutWrapper']:hover,
    [data-testid='bookie-price']:hover {
      background: var(--joe-white);
    }

    [class^='_navButtonWrapper_'] {
      color: var(--joe-black);
    }

    [class^='_offersButton_'] {
      color: var(--joe-black);
      text-transform: capitalize;
    }

    [data-testid='compare-odds'] {
      color: var(--joe-black);
    }

    [data-testid='compare-odds']:disabled {
      color: var(--joe-gray);
    }
  }
`;

export default joeThemeCss;
